const COLOR = {
    turquoise: "#1abc9c",
    turquoise50: "#e8f8f5",
    turquoise100: "#d1f2eb",
    turquoise200: "#a3e4d7",
    turquoise300: "#76d7c4",
    turquoise400: "#48c9b0",
    turquoise500: "#1abc9c",
    turquoise600: "#17a589",
    turquoise700: "#148f77",
    turquoise800: "#117864",
    turquoise900: "#0e6251",
  
    greenSea: "#16a085",
    greenSea50: "#e8f6f3",
    greenSea100: "#d0ece7",
    greenSea200: "#a2d9ce",
    greenSea300: "#73c6b6",
    greenSea400: "#45b39d",
    greenSea500: "#16a085",
    greenSea600: "#138d75",
    greenSea700: "#117a65",
    greenSea800: "#0e6655",
    greenSea900: "#0b5345",
  
    emerald: "#2ecc71",
    emerald50: "#eafaf1",
    emerald100: "#d5f5e3",
    emerald200: "#abebc6",
    emerald300: "#82e0aa",
    emerald400: "#58d68d",
    emerald500: "#2ecc71",
    emerald600: "#28b463",
    emerald700: "#239b56",
    emerald800: "#1d8348",
    emerald900: "#186a3b",
  
    nephritis: "#27ae60",
    nephritis50: "#e9f7ef",
    nephritis100: "#d4efdf",
    nephritis200: "#a9dfbf",
    nephritis300: "#7dcea0",
    nephritis400: "#52be80",
    nephritis500: "#27ae60",
    nephritis600: "#229954",
    nephritis700: "#1e8449",
    nephritis800: "#196f3d",
    nephritis900: "#145a32",
  
    peterRiver: "#3498db",
    peterRiver50: "#ebf5fb",
    peterRiver100: "#d6eaf8",
    peterRiver200: "#aed6f1",
    peterRiver300: "#85c1e9",
    peterRiver400: "#5dade2",
    peterRiver500: "#3498db",
    peterRiver600: "#2e86c1",
    peterRiver700: "#2874a6",
    peterRiver800: "#21618c",
    peterRiver900: "#1b4f72",
  
    belizeHole: "#2980b9",
    belizeHole50: "#eaf2f8",
    belizeHole100: "#d4e6f1",
    belizeHole200: "#a9cce3",
    belizeHole300: "#7fb3d5",
    belizeHole400: "#5499c7",
    belizeHole500: "#2980b9",
    belizeHole600: "#2471a3",
    belizeHole700: "#1f618d",
    belizeHole800: "#1a5276",
    belizeHole900: "#154360",
  
    amethyst: "#9b59b6",
    amethyst50: "#f5eef8",
    amethyst100: "#ebdef0",
    amethyst200: "#d7bde2",
    amethyst300: "#c39bd3",
    amethyst400: "#af7ac5",
    amethyst500: "#9b59b6",
    amethyst600: "#884ea0",
    amethyst700: "#76448a",
    amethyst800: "#633974",
    amethyst900: "#512e5f",
  
    wisteria: "#8e44ad",
    wisteria50: "#f4ecf7",
    wisteria100: "#e8daef",
    wisteria200: "#d2b4de",
    wisteria300: "#bb8fce",
    wisteria400: "#a569bd",
    wisteria500: "#8e44ad",
    wisteria600: "#7d3c98",
    wisteria700: "#6c3483",
    wisteria800: "#5b2c6f",
    wisteria900: "#4a235a",
  
    wetAsphalt: "#34495e",
    wetAsphalt50: "#ebedef",
    wetAsphalt100: "#d6dbdf",
    wetAsphalt200: "#aeb6bf",
    wetAsphalt300: "#85929e",
    wetAsphalt400: "#5d6d7e",
    wetAsphalt500: "#34495e",
    wetAsphalt600: "#2e4053",
    wetAsphalt700: "#283747",
    wetAsphalt800: "#212f3c",
    wetAsphalt900: "#1b2631",
  
    midnightBlue: "#2c3e50",
    midnightBlue50: "#eaecee",
    midnightBlue100: "#d5d8dc",
    midnightBlue200: "#abb2b9",
    midnightBlue300: "#808b96",
    midnightBlue400: "#566573",
    midnightBlue500: "#2c3e50",
    midnightBlue600: "#273746",
    midnightBlue700: "#212f3d",
    midnightBlue800: "#1c2833",
    midnightBlue900: "#17202a",
  
    sunflower: "#f1c40f",
    sunflower50: "#fef9e7",
    sunflower100: "#fcf3cf",
    sunflower200: "#f9e79f",
    sunflower300: "#f7dc6f",
    sunflower400: "#f4d03f",
    sunflower500: "#f1c40f",
    sunflower600: "#d4ac0d",
    sunflower700: "#b7950b",
    sunflower800: "#9a7d0a",
    sunflower900: "#7d6608",
  
    orange: "#f39c12",
    orange50: "#fef5e7",
    orange100: "#fdebd0",
    orange200: "#fad7a0",
    orange300: "#f8c471",
    orange400: "#f5b041",
    orange500: "#f39c12",
    orange600: "#d68910",
    orange700: "#b9770e",
    orange800: "#9c640c",
    orange900: "#7e5109",
  
    carrot: "#e67e22",
    carrot50: "#fdf2e9",
    carrot100: "#fae5d3",
    carrot200: "#f5cba7",
    carrot300: "#f0b27a",
    carrot400: "#eb984e",
    carrot500: "#e67e22",
    carrot600: "#ca6f1e",
    carrot700: "#af601a",
    carrot800: "#935116",
    carrot900: "#784212",
  
    pumpkin: "#d35400",
    pumpkin50: "#fbeee6",
    pumpkin100: "#f6ddcc",
    pumpkin200: "#edbb99",
    pumpkin300: "#e59866",
    pumpkin400: "#dc7633",
    pumpkin500: "#d35400",
    pumpkin600: "#ba4a00",
    pumpkin700: "#a04000",
    pumpkin800: "#873600",
    pumpkin900: "#6e2c00",
  
    alizarin: "#e74c3c",
    alizarin50: "#fdedec",
    alizarin100: "#fadbd8",
    alizarin200: "#f5b7b1",
    alizarin300: "#f1948a",
    alizarin400: "#ec7063",
    alizarin500: "#e74c3c",
    alizarin600: "#cb4335",
    alizarin700: "#b03a2e",
    alizarin800: "#943126",
    alizarin900: "#78281f",
  
    pomegranate: "#c0392b",
    pomegranate50: "#f9ebea",
    pomegranate100: "#f2d7d5",
    pomegranate200: "#e6b0aa",
    pomegranate300: "#d98880",
    pomegranate400: "#cd6155",
    pomegranate500: "#c0392b",
    pomegranate600: "#a93226",
    pomegranate700: "#922b21",
    pomegranate800: "#7b241c",
    pomegranate900: "#641e16",
  
    clouds: "#ecf0f1",
    clouds50: "#fdfefe",
    clouds100: "#fbfcfc",
    clouds200: "#f7f9f9",
    clouds300: "#f4f6f7",
    clouds400: "#f0f3f4",
    clouds500: "#ecf0f1",
    clouds600: "#d0d3d4",
    clouds700: "#b3b6b7",
    clouds800: "#979a9a",
    clouds900: "#7b7d7d",
  
    silver: "#bdc3c7",
    silver50: "#f8f9f9",
    silver100: "#f2f3f4",
    silver200: "#e5e7e9",
    silver300: "#d7dbdd",
    silver400: "#cacfd2",
    silver500: "#bdc3c7",
    silver600: "#a6acaf",
    silver700: "#909497",
    silver800: "#797d7f",
    silver900: "#626567",
  
    concrete: "#95a5a6",
    concrete50: "#f4f6f6",
    concrete100: "#eaeded",
    concrete200: "#d5dbdb",
    concrete300: "#bfc9ca",
    concrete400: "#aab7b8",
    concrete500: "#95a5a6",
    concrete600: "#839192",
    concrete700: "#717d7e",
    concrete800: "#5f6a6a",
    concrete900: "#4d5656",
  
    asbestos: "#7f8c8d",
    asbestos50: "#f2f4f4",
    asbestos100: "#e5e8e8",
    asbestos200: "#ccd1d1",
    asbestos300: "#b2babb",
    asbestos400: "#99a3a4",
    asbestos500: "#7f8c8d",
    asbestos600: "#707b7c",
    asbestos700: "#616a6b",
    asbestos800: "#515a5a",
    asbestos900: "#424949",
  };
  
  export default COLOR;
  